import axios from "axios";

const getDefaultState = () => {
  return {
    settings: {},
  };
};

// initial state
const state = getDefaultState();

const getters = {
  getPrivatInfoText: (state) => {
    return state.settings.privat_info_text;
  },

  getLogoUrl: (state) => {
    return "logo_url" in state.settings ? state.settings.logo_url : null;
  },

  getTimeSlotResolution: (state) => {
    return state.settings.time_slot_resolution;
  },

  getTimeSlotHeight: (state) => {
    return state.settings.time_slot_height;
  }
};

const actions = {

  async UpdateSettings({ commit, rootGetters }, data) {

    for (let key in data) {
      state.settings[key] = data[key];
    }

    let config = {
      headers: rootGetters["auth/authHeaders"],
    };

    return axios
      .put("settings/", data, config)
      .then((res) => {
        commit("setSettingsData", res.data);
      })
      .catch((err) => {
        console.log(err);
      }
    );
  },

  async GetSettingsData({ commit, rootGetters }) {
    let config = {
      headers: rootGetters["auth/authHeaders"],
    };

    return axios
      .get("settings/", config)
      .then((res) => {
        commit("setSettingsData", res.data);
      })
      .catch((err) => {
        console.log(err);
      });
  },

  async UploadLogo({ commit, rootGetters }, image) {
    let config = {
      headers: rootGetters["auth/authHeaders"],
    };

    let data = new FormData();
    data.append("file", image);
   
    return axios
      .put("upload/logo/", data, config)
      .then((res) => {
        commit("setLogoUrl", res.data.logoUrl);
      })
      .catch((err) => {
        console.log(err);
      });
  },
};

const mutations = {
  setSettingsData(state, data) {
    state.settings = data;
  },

  setLogoUrl(state, url) {
    state.settings.logo_url = url;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
